// extracted by mini-css-extract-plugin
export default {"title":"br_ceXbqph","tabContent":"vLdqYw1fWQ"};